import type { PropsWithChildren } from 'react'

export default function Wrapper({
  children,
  onClick,
}: PropsWithChildren<{
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}>) {
  return (
    <div
      onClick={onClick}
      className="relative z-[1] flex flex-col w-full sm:container sm:mx-auto xl:px-8 px-4 pt-8 mb-4 pb-8"
    >
      {children}
    </div>
  )
}
